export const countries = {
  1: 'BR'
};
